import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { IconComponent } from '@app/shared/components/icon/icon.component';

@Component({
  selector: 'app-hint',
  templateUrl: './hint.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    IconComponent,
    TooltipModule,
  ],
  host: {
    'class': 'tw-inline-flex'
  }
})
export class HintComponent {
  @Input() public tooltipText: string;
}
